module.exports = __webpack_public_path__ + "img/industry.722fb802.jpg";